import extractDomain from 'extract-domain';
import _ from 'lodash';
import Cookies from 'js-cookie';
import { parseJwt } from 'common/utils/utils';

import axios from '../requester.js';
import { LINB_API } from '../constants/api-urls.js';
import {
  COOKIES_KEYS,
  LOCAL_STORAGE_KEYS
} from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor.js';
import moment from 'moment';

const localStorageAccessor = BrowserStorageAccessor().local;
const minAccessTokenExpirationTimeMS = 9 * 1000; // 9 seconds
let accessTokenTimer = null;

export const domain = window.location.host.includes('localhost')
  ? 'localhost'
  : `.${extractDomain(window.location.host)}`;
export const getToken = () => Cookies.get(COOKIES_KEYS.TOKEN);

export const storeToken = (token, options = { path: '/' }) => {
  try {
    Cookies.set(COOKIES_KEYS.TOKEN, token, {
      ...options,
      expires: options.expires ? new Date(options.expires) : null
    });
    refreshAccessTokenOnExpiration(token);
    return Promise.resolve();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return Promise.reject(e);
  }
};

export const clearToken = () => {
  Cookies.remove(COOKIES_KEYS.TOKEN);
  Cookies.remove(COOKIES_KEYS.TOKEN, { path: '/', domain });
};

export const getParsedToken = () => {
  const token = getToken();
  return !token || _.isEmpty(token) ? {} : parseJwt(token);
};

export const fetchAndStoreNewRefreshAndAccessTokens = async (
  organizationId,
  isChangingOrg = false
) =>
  axios
    .get(LINB_API.TOKEN.RENEW, {
      withCredentials: true,
      params: {
        organizationId,
        isChangingOrg
      }
    })
    .then(({ token, cookieOptions }) => {
      Cookies.remove(COOKIES_KEYS.TOKEN);
      storeToken(token, cookieOptions);
      const accountId = parseJwt(token).id;
      localStorageAccessor.set(LOCAL_STORAGE_KEYS.ACCOUNT_ID, accountId);
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.error(e);
    });

export const refreshAccessTokenAndStoreInCookie = res => {
  try {
    if (!res || !res.token) {
      return null;
    }
    Cookies.remove(COOKIES_KEYS.TOKEN);
    storeToken(res.token, res.options);
    return res.token;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return null;
  }
};

export const refreshAccessTokenOnExpiration = async accessToken => {
  try {
    if (!accessToken || !parseJwt(accessToken)) {
      return null;
    }
    if (accessTokenTimer) {
      // Avoid more than one timer at once
      clearTimeout(accessTokenTimer);
      accessTokenTimer = null;
    }
    const acsTokExpirationDateSec = parseJwt(accessToken).exp;
    const acsTokExirationTimeMS = moment(acsTokExpirationDateSec * 1000).diff(
      moment()
    );
    if (acsTokExirationTimeMS > minAccessTokenExpirationTimeMS) {
      // To avoid flood of refresh token
      try {
        accessTokenTimer = setTimeout(async () => {
          accessTokenTimer = null;
          refreshAccessTokenAndStoreInCookie(
            await axios.get(LINB_API.TOKEN.REFRESH, {
              withCredentials: true
            })
          );
        }, acsTokExirationTimeMS);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};
